<template>
  <page-component
    id="webcontracts"
    header="My Contracts">
    <div
      id="webcontracts-results-counter"
      :class="{ mobile: device === 'mobile' }">
      <span
        >Showing results {{ filteredContracts.length }} of
        {{ contracts.length }}</span
      >
    </div>
    <search-filters-component
      id="webcontracts-filters-group"
      orientation="horizontal"
      :collapsed="false"
      :activeFilters="noActiveFilters"
      :addExtraSpace="true"
      :searchButton="{
        desktop: false,
        mobile: true
      }"
      :resetButton="{
        desktop: false,
        mobile: true
      }"
      @applyFilters="onMobileSearch(false)"
      @resetFilters="onMobileReset(false)">
      <div
        id="webcontracts-filters"
        :class="{ mobile: device === 'mobile' }">
        <div
          id="webcontracts-wordsearch-wrap"
          style="width: 505px"
          class="no-wrapper newline newline-combobox">
          <label
            id="webcontracts-wordsearch_label"
            for="webcontracts-wordsearch-input"
            class="fillin-label"
            >Search for Contract</label
          >
          <span class="ui-icon search"></span>
          <input
            id="webcontracts-wordsearch-input"
            class="fillin character"
            aria-labelledby="webcontracts-wordsearch_label"
            type="text"
            v-model="filters.keywordSearch"
            @input="onFilterChange('keyword', $event)"
            max-length="100" />
        </div>
        <div
          id="webcontracts-begindate-wrap"
          class="no-wrapper newline newline-combobox">
          <datepicker-component
            id="webcontracts-begindate"
            label="Begin Date"
            :modelValue="displayedBeginDate"
            @change="onFilterChange('beginDate', $event)">
          </datepicker-component>
        </div>
        <div
          id="webcontracts-enddate-wrap"
          class="no-wrapper newline newline-combobox">
          <datepicker-component
            id="webcontracts-enddate"
            label="End Date"
            :modelValue="displayedEndDate"
            @change="onFilterChange('endDate', $event)">
          </datepicker-component>
        </div>
        <div class="no-wrapper newline newline-combobox">
          <label
            id="webcontracts-status-filter_label"
            for="webcontracts-status-filter_button"
            >Payment Status</label
          >
          <combobox-component
            id="webcontracts-status-filter"
            displayStyle="list"
            emptyLabel="All"
            :multiple="false"
            :items="filters.paymentStatus.options"
            v-model="filters.paymentStatus.values"
            @change="onFilterChange('paymentStatusFilter', $event)">
          </combobox-component>
        </div>
      </div>
    </search-filters-component>
    <div
      id="webcontracts-contract-container-wrapper"
      ref="contractsContainerWrapper"
      class="scrollWrapper"
      :class="{ mobile: device === 'mobile' }">
      <div
        id="webcontracts-contract-container"
        class="scrollContainer"
        @scroll="onScrollContracts('contractsContainerWrapper')">
        <div class="topFade"></div>
        <div
          v-for="contract in filteredContracts"
          :key="contract.contractId"
          :id="'webcontracts-contract' + contract.contractId"
          :class="{
            'card-content': true,
            'collapsecontainer': true,
            'collapsecontainer--open': !contract.collapsed,
            'updating': contract.updating,
            'incart': contract.inCart
          }">
          <div
            :id="'card-inner-' + contract.contractId"
            class="card-inner">
            <div
              :class="{
                'card-inner__info': true,
                'mobile': device === 'mobile'
              }"
              @click.prevent="onClickCard(contract)">
              <div :id="'webcontracts-contract-left-' + contract.contractId">
                <div class="cardcollapseicon">
                  <button
                    :aria-label="
                      (contract.collapsed
                        ? 'Show contract items for '
                        : 'Hide contract items for ') +
                      contract.contractShortDescription
                    "
                    :aria-expanded="!contract.collapsed"
                    :class="{
                      'ui-icon': true,
                      'state-collapsed': contract.collapsed,
                      'state-expanded': !contract.collapsed
                    }"></button>
                </div>
              </div>
              <div :id="'webcontracts-contract-middle-' + contract.contractId">
                <div
                  :id="
                    'webcontracts-contract' + contract.contractId + '_header'
                  "
                  class="card-inner__header">
                  <h2
                    :id="
                      'webcontracts-contract' + contract.contractId + '_title'
                    ">
                    <span>{{ contract.contractShortDescription }}</span>
                  </h2>
                  <div
                    :id="
                      'webcontracts-contract' + contract.contractId + '_code'
                    "
                    class="card-inner__code">
                    {{ contract.contractCode }}
                  </div>
                </div>
                <div
                  :id="'webcontracts-contract' + contract.contractId + '_term'"
                  class="card-inner__dates">
                  <span class="ui-icon calendar"></span>
                  <strong> Begin Date:</strong> {{ contract.contractStart }} |
                  <strong>End Date:</strong> {{ contract.contractEnd }}
                </div>
              </div>
              <div :id="'webcontracts-contract-right-' + contract.contractId">
                <div
                  :id="'webcontracts-contract-totals-' + contract.contractId">
                  <div
                    :id="
                      'webcontracts-contract' + contract.contractId + '_status'
                    "
                    class="card-inner__description">
                    <strong>Contract Items:</strong>
                    {{ contract.contractCount }}
                  </div>
                  <div
                    :id="
                      'webcontracts-contract' +
                      contract.contractId +
                      '_totalfees'
                    "
                    class="card-inner__description">
                    <strong>Fees To Date:</strong>
                    {{ contract.contractTotalFees }}
                  </div>
                  <div
                    :id="
                      'webcontracts-contract' +
                      contract.contractId +
                      '_totaldue'
                    "
                    class="card-inner__description">
                    <strong>Balance Due:</strong>
                    {{ contract.contractTotalDue }}
                  </div>
                </div>
                <div class="right-buttons-wrapper">
                  <button
                    v-if="contract.contractTotalDue != '$0.00'"
                    :id="
                      'webcontracts-contract' + contract.contractId + 'payment'
                    "
                    type="button"
                    class="button primary no-overlay"
                    aria-label="Pay Balance"
                    @click.prevent="onClickPayment(contract)">
                    Pay Balance
                  </button>
                  <button
                    v-if="contract.contractDocument != ''"
                    :id="
                      'webcontracts-contract' +
                      contract.contractId +
                      '_download'
                    "
                    type="button"
                    class="button secondary no-overlay"
                    :aria-label="
                      'Download Contract ' + contract.contractShortDescription
                    "
                    @click.prevent="onDownload(contract)">
                    Download
                  </button>
                </div>
                <div class="notification-container">
                  <div
                    v-if="contract.updating === true"
                    :id="
                      'webcontracts-contract' +
                      contract.contractId +
                      '_updating'
                    "
                    class="card-inner__updating notification">
                    Update in Progress...
                  </div>
                  <div
                    v-if="contract.inCart === true"
                    :id="
                      'webcontracts-contract' + contract.contractId + '_incart'
                    "
                    class="card-inner__incart notification">
                    Items in Cart
                  </div>
                </div>
              </div>
            </div>
            <div
              :id="'webcontracts-contract-bottom-' + contract.contractId"
              class="result-content"
              v-if="!contract.collapsed">
              <table
                :id="'webcontracts-table-' + contract.contractId"
                class="table">
                <caption class="sr-only">
                  Contract Items for
                  {{
                    contract.contractShortDescription
                  }}
                </caption>
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Item Detail Count</th>
                    <th>Fees To Date</th>
                    <th>Total Paid</th>
                    <th>Balance Due</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody v-if="contractItems.length != 0">
                  <tr
                    v-for="contractitem in resultsContractItems(
                      contract.contractId
                    )"
                    :key="contractitem.itemId">
                    <td class="label-cell">
                      <span
                        class="mobile-column-header"
                        aria-hidden="true"
                        >Description</span
                      >
                      {{ contractitem.itemDescription }}
                    </td>
                    <td class="label-cell">
                      <span
                        class="mobile-column-header"
                        aria-hidden="true"
                        >Item Detail Count</span
                      >
                      {{ contractitem.itemCount }}
                    </td>
                    <td class="label-cell">
                      <span
                        class="mobile-column-header"
                        aria-hidden="true"
                        >Fees To Date</span
                      >
                      {{ contractitem.itemTotalFees }}
                    </td>
                    <td class="label-cell">
                      <span
                        class="mobile-column-header"
                        aria-hidden="true"
                        >Total Paid</span
                      >
                      {{ contractitem.itemTotalPaid }}
                    </td>
                    <td class="label-cell">
                      <span
                        class="mobile-column-header"
                        aria-hidden="true"
                        >Balance Due</span
                      >
                      {{ contractitem.itemTotalDue }}
                    </td>
                    <td>
                      <button
                        :id="'webcontracts-itemdetails' + contractitem.itemId"
                        type="button"
                        class="button tertiary"
                        style="margin-top: 0px"
                        :aria-label="
                          'Item Details for ' + contractitem.itemDescription
                        "
                        aria-haspopup="dialog"
                        @click.prevent="onItemDetails(contract, contractitem)">
                        Item Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="bottomPadding"></div>
        <div class="bottomFade"></div>
      </div>
      <button
        id="webcontracts-scroll-top-button"
        class="button primary scrollTop"
        @click.prevent="scrollTopContracts('contractsContainerWrapper')">
        <span>Top</span>
      </button>
    </div>
    <dialog-component
      v-if="showItemDetails"
      id="webcontracts-item-details-dialog"
      :selector="'#webcontracts-contract' + itemDetailsContract.contractId"
      :title="
        itemDetailsContract.contractShortDescription +
        ': ' +
        itemDetailsItem.itemDescription +
        ' - Item Details'
      "
      :hasButtonPane="false"
      @close="showItemDetails = false">
      <div
        :id="`${itemDetailsContract.contractId}-dialog-box`"
        class="dialog-box"
        :class="{ mobile: device === 'mobile' }">
        <div
          id="webcontracts-item-details-content"
          class="content twocolumn-layout">
          <search-filters-component
            id="webcontracts-item-details-filters"
            orientation="vertical"
            :addExtraSpace="true"
            :activeFilters="noActiveDetailFilters"
            :searchButton="{
              desktop: false,
              mobile: true
            }"
            :resetButton="{
              desktop: true,
              mobile: true
            }"
            @applyFilters="onItemSearch"
            @resetFilters="itemFilterReset">
            <div
              id="webcontracts-item-date-wrap"
              class="newline search-criteria newline-combobox">
              <datepicker-component
                id="webcontracts-item-date"
                label="Item Date"
                :modelValue="displayedItemDate"
                @change="onItemFilterChange('date', $event)">
              </datepicker-component>
            </div>
            <div
              id="webcontracts-item-status-wrap"
              class="newline search-criteria newline-combobox">
              <label
                id="webcontracts-item-status-filter_label"
                for="webcontracts-item-status-label"
                >Status</label
              >
              <div class="field-wrap combobox-field-wrap">
                <combobox-component
                  id="webcontracts-item-status-filter"
                  displayStyle="list"
                  :multiple="true"
                  emptyLabel="All Statuses"
                  :items="itemFilters.status.options"
                  v-model="itemFilters.status.values"
                  @change="onItemFilterChange('status', $event)">
                </combobox-component>
              </div>
            </div>
          </search-filters-component>
          <div
            :id="`${itemDetailsContract.contractId}-dialog-box-content`"
            ref="itemDetailWrapper"
            class="dialog-box-content scrollWrapper"
            :class="{ mobile: device === 'mobile' }">
            <div
              id="webcontracts-contract-items"
              class="scrollContainer"
              @scroll="onScrollContracts('itemDetailWrapper')">
              <div class="topFade"></div>
              <div
                v-for="itemDetail in filteredContractItemDetails"
                :key="itemDetail.detailId"
                :id="'webcontracts-contract-item' + itemDetail.detailId"
                :class="{
                  'card-content': true,
                  'collapsecontainer': true,
                  'dialog-card-container': true,
                  'collapsecontainer--open': !itemDetail.collapsed
                }">
                <div class="card-inner">
                  <div
                    class="card-inner__info"
                    :class="{ mobile: device === 'mobile' }"
                    @click.prevent="
                      onClickDetailCard(
                        itemDetailsContract.contractId,
                        itemDetail
                      )
                    ">
                    <div
                      :id="
                        'webcontracts-contract-items-left-' +
                        itemDetail.detailId
                      ">
                      <button
                        type="button"
                        class="cardcollapseicon"
                        :aria-expanded="!itemDetail.collapsed"
                        :aria-label="
                          (itemDetail.collapsed ? 'Show' : 'Hide') +
                          ' fee details for ' +
                          itemDetail.detailDisplayDate
                        "
                        @click.prevent.stop="
                          onClickDetailCard(
                            itemDetailsContract.contractId,
                            itemDetail
                          )
                        ">
                        <span class="ui-icon"></span>
                      </button>
                    </div>
                    <div
                      :id="
                        'webcontracts-contract-items-right-' +
                        itemDetail.detailId
                      ">
                      <div class="contract-items-column">
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_dates'
                          "
                          class="card-inner__description">
                          <strong>Dates:</strong>
                          <div>{{ itemDetail.detailDisplayDate }}</div>
                        </div>
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_times'
                          "
                          class="card-inner__description">
                          <strong>Times:</strong>
                          <div>{{ itemDetail.detailDisplayTime }}</div>
                        </div>
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_status'
                          "
                          class="card-inner__description">
                          <strong>Status:</strong>
                          <div>{{ itemDetail.detailStatus }}</div>
                        </div>
                      </div>
                      <div class="contract-items-column">
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_totalfees'
                          "
                          class="card-inner__description">
                          <strong>Fees To Date:</strong>
                          <div>{{ itemDetail.detailTotalFees }}</div>
                        </div>
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_totalpaid'
                          "
                          class="card-inner__description">
                          <strong>Total Paid:</strong>
                          <div>{{ itemDetail.detailTotalPaid }}</div>
                        </div>
                        <div
                          :id="
                            'webcontracts-contract-item' +
                            itemDetail.detailId +
                            '_totaldue'
                          "
                          class="card-inner__description">
                          <strong>Balance Due:</strong>
                          <div>{{ itemDetail.detailTotalDue }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :id="
                      'webcontracts-contract-items-bottom-' +
                      itemDetail.detailId
                    "
                    class="result-content"
                    v-if="!itemDetail.collapsed">
                    <table
                      :id="'webcontracts-items-table-' + itemDetail.detailId"
                      class="table">
                      <caption
                        v-if="contractItemDetailFees.length > 0"
                        class="sr-only">
                        Associated fees for Item Detail
                        {{
                          itemDetail.detailDisplayDate
                        }}
                        {{
                          itemDetail.detailDisplayTime
                        }}
                        with status
                        {{
                          itemDetail.detailStatus
                        }}
                      </caption>
                      <caption
                        v-else
                        class="sr-only">
                        No associated fees for Item Detail
                        {{
                          itemDetail.detailDisplayDate
                        }}
                        {{
                          itemDetail.detailDisplayTime
                        }}
                        with status
                        {{
                          itemDetail.detailStatus
                        }}
                      </caption>
                      <thead>
                        <tr>
                          <th>Fee Description</th>
                          <th>Amount</th>
                          <th>Discount</th>
                          <th>Tax</th>
                          <th>Quantity</th>
                          <th>Time Count</th>
                          <th>Net Fee</th>
                          <th>Fee Paid</th>
                        </tr>
                      </thead>
                      <tbody v-if="contractItemDetailFees.length != 0">
                        <tr
                          v-for="detailfee in resultsDetailFees(
                            itemDetail.detailId
                          )"
                          :key="detailfee.feeId">
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Fee Description</span
                            >
                            {{ detailfee.feeDescription }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Amount</span
                            >
                            {{ detailfee.feeAmount }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Discount</span
                            >
                            {{ detailfee.feeDiscount }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Tax</span
                            >
                            {{ detailfee.feeTaxAmount }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Quantity</span
                            >
                            {{ detailfee.feeQuantity }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Time Count</span
                            >
                            {{ detailfee.feeTimeCount }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Net Fee</span
                            >
                            {{ detailfee.feeNetFee }}
                          </td>
                          <td class="label-cell">
                            <span
                              class="mobile-column-header"
                              aria-hidden="true"
                              >Fee Paid</span
                            >
                            {{ detailfee.feePaid }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      :id="
                        'webcontracts-fees-empty-message-' + itemDetail.detailId
                      "
                      class="message"
                      v-if="contractItemDetailFees.length === 0">
                      There are no fees associated with this item.
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="webcontracts-empty-message"
                class="message"
                v-if="filteredContractItemDetails.length === 0">
                There are no items available based on the filters.
              </div>
              <div class="bottomPadding"></div>
              <div class="bottomFade"></div>
            </div>
            <button
              id="webcontracts-details-scroll-top-button"
              class="button primary scrollTop"
              @click.prevent="scrollTopContracts('itemDetailWrapper')">
              <span>Top</span>
            </button>
          </div>
        </div>
      </div>
    </dialog-component>
    <div
      id="webcontracts-empty-message"
      class="message"
      v-if="filteredContracts.length === 0">
      There are no contracts available based on the filters.
    </div>
  </page-component>
</template>

<script>
import MyContractsServices from '@/services/MyContractsServices'
import { mutations } from '@/store/types'

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export default {
  name: 'MyContracts',
  props: {
    begindate: String,
    enddate: String,
    paymentstatus: String,
    searchcontract: [String, Number],
    initcontracts: Array,
    totalcontracts: Number
  },
  data() {
    return {
      csrf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      contracts: [],
      filteredContracts: [],
      contractItems: [],
      contractItemDetails: [],
      filteredContractItemDetails: [],
      contractItemDetailFees: [],
      displayedBeginDate: '',
      displayedEndDate: '',
      displayedItemDate: '',
      filters: {
        beginDate: null,
        endDate: null,
        keywordSearch: '',
        paymentStatus: {
          options: [
            { label: 'All', value: '' },
            { label: 'Paid in Full', value: 'paid in full' },
            { label: 'Payment Due', value: 'payment due' }
          ],
          values: []
        }
      },
      itemFilters: {
        date: null,
        status: {
          options: [],
          values: []
        }
      },
      device: 'desktop',
      noActiveFilters: 0,
      noActiveDetailFilters: 0,
      itemDetailsContract: null,
      itemDetailsItem: null,
      showItemDetails: false
    }
  },
  created() {
    this.contracts = this.initcontracts
    this.filters.keywordSearch = this.searchcontract.toString()
    this.filters.paymentStatus.values = [this.paymentstatus.toString()]
    this.resetDates()

    window.addEventListener('resize', this.onResizeWindow)
    document.addEventListener('orientationchange', this.onResizeWindow)
    this.onResizeWindow()

    if (this.contracts.length != 0)
      this.contracts.forEach((c) => {
        c.contractTotalFees = USDollar.format(c.contractTotalFees)
        c.contractTotalPaid = USDollar.format(c.contractTotalPaid)
        c.contractTotalDue = USDollar.format(c.contractTotalDue)
        if (c.contractStart === null) c.contractStart = '-'
        if (c.contractEnd === null) c.contractEnd = '-'
      })

    this.onSearch()
    if (this.totalcontracts > 2000) {
      setTimeout(() => {
        this.getAdditionalContracts()
      }, 500)
    }

    // update the skip links; this needs to happen here for now
    $('.skip-link.skip-search').attr('href', '#webcontracts-filters-group')
    $('.skip-link.skip-main').attr(
      'href',
      '#webcontracts-contract-container-wrapper'
    )
  },

  mounted() {
    this.setContractsContainerHeight()
    this.onScrollContracts('contractsContainerWrapper')
  },

  unmounted() {
    window.removeEventListener('resize', this.onResizeWindow)
    document.removeEventListener('orientationchange', this.onResizeWindow)
  },

  methods: {
    onResizeWindow() {
      const windowWidth = document.documentElement.clientWidth
      setTimeout(() => {
        this.setContractsContainerHeight()
        this.onScrollContracts('contractsContainerWrapper')
      }, '100')

      if (windowWidth <= 990) this.device = 'mobile'
      else this.device = 'desktop'
    },

    onClickFilterGroup() {
      setTimeout(() => {
        this.setContractsContainerHeight()
        this.onScrollContracts('contractsContainerWrapper')
      }, '100')
    },

    setContractsContainerHeight() {
      if (!this.$refs.contractsContainerWrapper) return

      if (this.filteredContracts.length === 0) {
        this.$refs.contractsContainerWrapper.style.height = '0px'
        return
      }

      const windowHeight = window.innerHeight
      const headerHeight = $('#header').outerHeight(true)
      const titleHeight = $('.page-header').outerHeight(true)
      const filterHeight = $('#webcontracts-filters-group').outerHeight(true)
      const cardMarginHeight = 32
      const containerHeight =
        windowHeight -
        headerHeight -
        titleHeight -
        filterHeight -
        cardMarginHeight

      if (containerHeight > filterHeight + cardMarginHeight)
        this.$refs.contractsContainerWrapper.style.height =
          containerHeight + 'px'
      else
        this.$refs.contractsContainerWrapper.style.height =
          filterHeight + cardMarginHeight + 'px'
    },

    setItemDetailContainerHeight() {
      const windowHeight = window.innerHeight
      const titleBarHeight = $('.ui-dialog-titlebar').outerHeight(true)
      const containerHeight = windowHeight - titleBarHeight - 80
      this.$refs.itemDetailWrapper.style.height = containerHeight + 'px'
    },

    onScrollContracts(elementRef) {
      if (!this.$refs[elementRef]) return

      const scrollContainer = $(this.$refs[elementRef]).find(
        '.scrollContainer'
      )[0]
      const topFade = $(this.$refs[elementRef]).find('.topFade')[0]
      const bottomFade = $(this.$refs[elementRef]).find('.bottomFade')[0]
      const scrollTop = $(this.$refs[elementRef]).find('.scrollTop')[0]

      if (scrollContainer.scrollTop === 0) {
        topFade.style.visibility = 'hidden'
        scrollTop.style.visibility = 'hidden'
      } else {
        topFade.style.visibility = 'visible'
        scrollTop.style.visibility = 'visible'
      }

      if (
        scrollContainer.scrollTop + scrollContainer.clientHeight + 2 >=
        scrollContainer.scrollHeight
      ) {
        bottomFade.style.visibility = 'hidden'
      } else {
        bottomFade.style.visibility = 'visible'
      }
    },

    scrollTopContracts(elementRef) {
      const scrollContainer = $(this.$refs[elementRef]).find(
        '.scrollContainer'
      )[0]
      const scrollTop = $(this.$refs[elementRef]).find('.scrollTop')[0]

      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' })
      scrollContainer.querySelector('button').focus() // focus the first expand/collapse button
      scrollTop.visibility = 'hidden'
    },

    onSearch() {
      let singleContract = []

      this.calcNoActiveFilters()

      if (
        this.filters.keywordSearch != '' &&
        !isNaN(this.filters.keywordSearch)
      )
        singleContract = this.contracts.find(
          (c) => c.contractId == this.filters.keywordSearch
        )

      if (singleContract && singleContract.length !== 0) {
        this.filteredContracts = this.contracts.filter((contract) => {
          if (contract.contractId != singleContract.contractId) {
            contract.collapsed = true
            return false
          }

          this.onClickCard(contract)

          return true
        })
      } else {
        this.filteredContracts = this.contracts.filter((contract) => {
          if (
            this.filters.beginDate != null &&
            contract.contractStart != '-' &&
            this.getFormattedSortDate(new Date(contract.contractStart)) <
              this.getFormattedSortDate(this.filters.beginDate)
          ) {
            contract.collapsed = true
            return false
          }

          if (
            this.filters.endDate != null &&
            contract.contractEnd != '-' &&
            this.getFormattedSortDate(new Date(contract.contractEnd)) >
              this.getFormattedSortDate(this.filters.endDate)
          ) {
            contract.collapsed = true
            return false
          }

          if (this.filters.paymentStatus.values[0] != '') {
            if (
              (this.filters.paymentStatus.values[0].toLowerCase() ===
                'paid in full' &&
                contract.contractTotalDue != '$0.00') ||
              (this.filters.paymentStatus.values[0].toLowerCase() ===
                'payment due' &&
                contract.contractTotalDue === '$0.00')
            ) {
              contract.collapsed = true
              return false
            }
          }

          if (
            this.filters.keywordSearch != '' &&
            !contract.contractCode
              .toLowerCase()
              .includes(this.filters.keywordSearch.toLowerCase()) &&
            !contract.contractShortDescription
              .toLowerCase()
              .includes(this.filters.keywordSearch.toLowerCase())
          ) {
            contract.collapsed = true
            return false
          }

          return true
        })
      }

      this.$nextTick(() => {
        this.setContractsContainerHeight()
        this.onScrollContracts('contractsContainerWrapper')
      })
    },
    onItemSearch() {
      this.filteredContractItemDetails = this.contractItemDetails.filter(
        (itemDetails) => {
          if (
            this.itemFilters.date != null &&
            itemDetails.detailBeginDate >
              this.getFormattedSortDate(this.itemFilters.date)
          ) {
            return false
          }

          if (
            this.itemFilters.date != null &&
            itemDetails.detailEndDate <
              this.getFormattedSortDate(this.itemFilters.date)
          ) {
            return false
          }

          if (
            !this.itemFilters.status.values.includes(itemDetails.detailStatus)
          ) {
            return false
          }

          return true
        }
      )

      this.noActiveDetailFilters = 0
      if (this.itemFilters.date !== null) this.noActiveDetailFilters += 1

      setTimeout(() => {
        this.onScrollContracts('itemDetailWrapper')
      }, '100')
    },
    resetDates() {
      if (this.begindate) {
        this.filters.beginDate = new Date(this.begindate)
        this.displayedBeginDate = this.begindate
      } else {
        let date = new Date()
        date.setFullYear(date.getFullYear() - 1)
        this.filters.beginDate = date
        this.displayedBeginDate = this.getFormattedDate(date)
      }

      if (this.enddate) {
        this.filters.endDate = new Date(this.enddate)
        this.displayedEndDate = this.getFormattedDate(this.filters.endDate)
      } else {
        let date = new Date()
        date.setFullYear(date.getFullYear() + 1)
        this.filters.endDate = date
        this.displayedEndDate = this.getFormattedDate(date)
      }
    },
    resetItemDate() {
      this.itemFilters.date = null
      this.displayedItemDate = ''
    },
    resetItemStatus() {
      this.itemFilters.status.options = [
        ...new Set(
          this.contractItemDetails.map((itemDetail) => itemDetail.detailStatus)
        )
      ].map((option) => {
        return { label: option, value: option }
      })
      this.itemFilters.status.values = this.itemFilters.status.options
        .map((option) => option.value)
        .filter((value) => value !== 'Cancelled' && value !== 'Change')
    },
    itemFilterReset() {
      this.resetItemDate()
      this.resetItemStatus()
      this.onItemSearch()
    },
    onFilterChange(filterName, event) {
      if (filterName === 'beginDate') {
        this.filters.beginDate = new Date(event)
        this.displayedBeginDate = this.getFormattedDate(this.filters.beginDate)
      }
      if (filterName === 'endDate') {
        this.filters.endDate = new Date(event)
        this.displayedEndDate = this.getFormattedDate(this.filters.endDate)
      }

      if (this.device === 'desktop') this.onSearch()
    },
    onItemFilterChange(filterName, event) {
      if (filterName === 'date') {
        this.itemFilters.date = new Date(event)
        this.displayedItemDate = this.getFormattedDate(this.itemFilters.date)
      }

      if (this.device === 'desktop') this.onItemSearch()
    },
    onMobileSearch() {
      this.onSearch()
    },
    onMobileReset() {
      this.noActiveFilters = 0
      this.filters.paymentStatus.values[0] = ''
      this.filters.keywordSearch = ''
      this.resetDates()
      this.onSearch()
    },
    calcNoActiveFilters() {
      this.noActiveFilters = 0
      if (
        this.filters.paymentStatus.values[0] &&
        this.filters.paymentStatus.values[0] !== ''
      )
        this.noActiveFilters += 1
      if (this.filters.beginDate) this.noActiveFilters += 1
      if (this.filters.endDate) this.noActiveFilters += 1
      if (this.filters.keywordSearch) this.noActiveFilters += 1
    },
    resultsContracts() {
      const uniqueContractIds = new Set()
      const uniqueContracts = []
      for (let ix = 0; ix < this.contracts.length; ix++) {
        if (!uniqueContractIds.has(this.contracts[ix].contractId)) {
          uniqueContracts.push(this.contracts[ix])
          uniqueContractIds.add(this.contracts[ix].contractId)
        }
      }

      return uniqueContracts.sort((a, b) => {
        if (a.contractId < b.contractId) return 1
        if (a.contractId > b.contractId) return -1

        return 0
      })
    },
    resultsContractItems(id) {
      return this.contractItems
        .filter((d) => d.contractId === id)
        .sort((a, b) => {
          if (a.itemDescription > b.itemDescription) return 1
          if (a.itemDescription < b.itemDescription) return -1

          return 0
        })
    },
    resultsDetailFees(id) {
      return this.contractItemDetailFees
        .filter((d) => d.detailId === id)
        .sort((a, b) => {
          if (a.feeDescription > b.feeDescription) return 1
          if (a.feeDescription < b.feeDescription) return -1

          return 0
        })
    },
    onDownload(c) {
      if (c) {
        const toDownload =
          'downloadfile.html?action=ViewFile&BlobFileName=' +
          c.contractDocument.replaceAll('\\', '%5c')

        window.open(toDownload, '_blank')

        if (!c.inCart) c.collapsed = !c.collapsed
      }

      return
    },
    onClickPayment(c) {
      if (c) {
        if (!c.inCart) c.collapsed = !c.collapsed

        this.$store.state.showOverlay = true

        MyContractsServices.getContractPayment(c.contractId)
          .then((data) => {
            if (data.success) {
              window.location.replace(App.settings.BaseHref + 'cart.html?_csrf_token=' + encodeURIComponent(this.csrf))
              return
            }

            this.$store.commit(mutations.ADD_MESSAGE, {
              type: 'error',
              text:
                data.error || `Unable to pay balance, please try again later.`
            })

            this.$store.state.showOverlay = false
          })
          .catch(() => {
            this.$store.state.showOverlay = false
          })
      }

      return
    },
    getAdditionalContracts() {
      let maxPage = Math.ceil(this.totalcontracts / 1000)

      MyContractsServices.getContracts(maxPage)
        .then((data) => {
          if (data.contracts.length != 0)
            data.contracts.forEach((c) => {
              c.contractTotalFees = USDollar.format(c.contractTotalFees)
              c.contractTotalPaid = USDollar.format(c.contractTotalPaid)
              c.contractTotalDue = USDollar.format(c.contractTotalDue)

              if (c.contractStart === null) c.contractStart = '-'
              if (c.contractEnd === null) c.contractEnd = '-'
            })

          this.contracts = this.contracts.concat(data.contracts)
          this.contracts = this.resultsContracts()
          this.onSearch()
        })
        .catch(() => {})

      return
    },
    onClickCard(c) {
      if (c.inCart) return

      if (c) {
        this.filteredContracts.forEach((fc) => {
          if (fc.contractId != c.contractId) fc.collapsed = true
        })

        c.collapsed = !c.collapsed
      }

      MyContractsServices.getContractItems(c.contractId)
        .then((items) => {
          this.contractItems = items

          if (this.contractItems.length != 0)
            this.contractItems.forEach((d) => {
              d.itemTotalFees = USDollar.format(d.itemTotalFees)
              d.itemTotalPaid = USDollar.format(d.itemTotalPaid)
              d.itemTotalDue = USDollar.format(d.itemTotalDue)
            })

          this.$nextTick(() => {
            this.setContractsContainerHeight()
            this.onScrollContracts('contractsContainerWrapper')
          })
        })
        .catch(() => {})

      return
    },
    onItemDetails(c, ci) {
      this.itemDetailsContract = c
      this.itemDetailsItem = ci
      this.resetItemDate()

      if (this.device === 'mobile') {
        setTimeout(() => {
          this.setItemDetailContainerHeight()
        }, '100')
      }

      MyContractsServices.getContractItemDetails(c.contractId, ci.itemId)
        .then((details) => {
          this.contractItemDetails = details
          this.resetItemStatus()
          this.onItemSearch()

          if (this.contractItemDetails.length != 0)
            this.contractItemDetails.forEach((d) => {
              d.detailTotalFees = USDollar.format(d.detailTotalFees)
              d.detailTotalPaid = USDollar.format(d.detailTotalPaid)
              d.detailTotalDue = USDollar.format(d.detailTotalDue)
            })

          setTimeout(() => {
            this.onScrollContracts('itemDetailWrapper')
          }, '100')
        })
        .catch(() => {})

      this.showItemDetails = true

      return
    },
    onClickDetailCard(contractid, d) {
      if (d) {
        this.filteredContractItemDetails.forEach((fd) => {
          if (fd.detailId != d.detailId) fd.collapsed = true
        })

        d.collapsed = !d.collapsed
      }

      MyContractsServices.getContractItemDetailFees(contractid, d.detailId)
        .then((fees) => {
          this.contractItemDetailFees = fees

          if (this.contractItemDetailFees.length != 0)
            this.contractItemDetailFees.forEach((df) => {
              df.feeAmount = USDollar.format(df.feeAmount)
              df.feeDiscount = USDollar.format(df.feeDiscount)
              df.feeTaxAmount = USDollar.format(df.feeTaxAmount)
              df.feeNetFee = USDollar.format(df.feeNetFee)
              df.feePaid = USDollar.format(df.feePaid)
              df.feeDue = USDollar.format(df.feeDue)
            })
        })
        .catch(() => {})

      return
    },
    getFormattedDate(date) {
      const year = date.getFullYear()
      const month = (1 + date.getMonth()).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')

      return month + '/' + day + '/' + year
    },
    getFormattedSortDate(date) {
      const year = date.getFullYear()
      const month = (1 + date.getMonth()).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')

      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/abstract/variables';
@import '../../assets/css/abstract/mixins';
@import '../../assets/css/components/table';

.scrollWrapper {
  overflow: hidden;
  position: relative;

  .scrollContainer {
    .default-focus-indicator(-2px, @primary-color); //some browsers (eg. Firefox) include this container in the tab sequence when there is a scrollbar
    position: absolute;
    top: 16px;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    width: 100%;

    .topFade {
      height: 100px;
      width: -webkit-fill-available;
      position: sticky;
      top: 0px;
      margin-top: -100px;
      z-index: 1;
      background: linear-gradient(
        180deg,
        rgba(242, 242, 242, 1) 0%,
        rgba(255, 255, 255, 0.711922268907563) 20%,
        rgba(255, 255, 255, 0) 100%
      );
      pointer-events: none;
    }

    .bottomPadding {
      height: 15px;
    }

    .bottomFade {
      height: 100px;
      width: -webkit-fill-available;
      position: sticky;
      bottom: 0px;
      margin-top: -100px;
      z-index: 1;
      background: linear-gradient(
        0deg,
        rgba(242, 242, 242, 1) 0%,
        rgba(255, 255, 255, 0.711922268907563) 20%,
        rgba(255, 255, 255, 0) 100%
      );
      pointer-events: none;
    }

    &:focus-visible .topFade,
    &:focus-visible .bottomFade {
      background: none;
    }
  }

  .scrollTop {
    position: absolute;
    bottom: 5px;
    right: 22px;
    z-index: 4;
    border-radius: 50%;
    height: 45px;
    width: 45px;
    opacity: 0.86;

    &.mobile {
      bottom: -4px;
      right: 8px;
    }

    span {
      margin-left: -6.5px;
    }
  }

  .scrollTop:hover,
  .scrollTop:focus {
    opacity: 1;
  }
}

#webcontracts {
  #webcontracts-contract-container-wrapper.mobile {
    width: 100%;

    h2 {
      padding-right: 125px;
    }

    .collapsecontainer {
      .right-buttons-wrapper {
        display: none;
      }
    }

    .collapsecontainer--open {
      div[id^='webcontracts-contract-left'] {
        margin-top: -14px;
      }

      .right-buttons-wrapper {
        display: block;
      }

      .card-inner__header {
        height: unset !important;
      }

      h2 {
        padding-right: 0;
      }
    }

    div[id^='webcontracts-contract-left'] {
      padding-right: 0px;
      align-self: center;
    }

    div[id^='webcontracts-contract-middle'] {
      padding-right: 0px;

      .card-inner__header {
        height: 43px;
      }
    }

    div[id^='webcontracts-contract-right'] {
      width: 100%;
      padding-right: 8px;

      .right-buttons-wrapper {
        width: 100%;
      }
    }
  }

  #webcontracts-results-counter {
    margin-bottom: 24px;
    font-size: 14px;

    span {
      float: right;
    }
  }

  #webcontracts-results-counter.mobile {
    margin-bottom: 0px;
    margin-top: 3px;

    span {
      float: left;
    }
  }

  #webcontracts-filters {
    display: flex;

    .newline {
      display: inline-grid;
      width: 16%;
      padding-right: 16px;

      label {
        width: 100%;
      }
    }
  }

  #webcontracts-filters.mobile {
    .newline {
      width: 100% !important;
      padding-right: 0px;
    }
  }

  #webcontracts-filters-group {
    margin: 16px 0px 3px 0px;
    border: 1px solid hsla(0, 0%, 75%, 0.5);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    .header.group__header {
      display: block;
    }

    .group__inner {
      padding: 16px;
      background: #fff;

      #webcontracts-wordsearch-wrap {
        position: relative;

        input {
          padding-left: 30px;
        }

        .ui-icon.search {
          background-image: url('../../assets/img/icons/glyph/16/freeformsearch.svg');
          background-position-x: center;
          background-position-y: center;
          position: absolute;
          bottom: 26px;
          left: 9px;
        }
      }
    }
  }

  #webcontracts-filters-group.mobile {
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
}

.card-content.incart {
  .ui-icon {
    display: none;
  }

  &:hover {
    background-color: #ffffff;
    cursor: default;
  }
}

.card-content ~ .card-content {
  margin-top: 16px;
}

.card-content {
  margin-top: 0;
  border: 1px solid rgba(192, 192, 192, 0.5);
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  box-sizing: border-box;

  &:hover {
    background-color: #f7f7f7;
  }

  .card-inner {
    display: flex;
    margin: 0;
    padding: 0;
    border-style: none;
    border-radius: 0;
    background-image: none;
    text-indent: 0;
    line-height: 1rem;
    flex-direction: column;

    h2 {
      font-size: @font-size-16px;
      margin: 0;
      font-weight: 600;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: normal;
    }

    &__info {
      .default-focus-indicator(-2px, @primary-color);
      padding: 10px 15px;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      position: relative;
    }

    &__info.mobile {
      display: flex !important;
      flex-wrap: wrap;
      padding-left: 8px;
      padding-right: 0px;

      div[id^='webcontracts-contract-right'] {
        flex-wrap: wrap;
      }
    }

    &__description {
      padding: 0;
      line-height: 1.7;
      font-size: @font-size-12px;
      float: left;
      width: 100%;
    }

    &__header {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin-bottom: 5px;
    }

    &__dates {
      font-size: @font-size-12px;
      background-color: #e8e8e8;
      border-radius: 3px;
      float: left;
      width: fit-content;
      padding: 2px 5px;

      .ui-icon.calendar {
        background-image: url('../../assets/img/icons/outline/16/calendar.svg');
        background-position-x: center;
        background-position-y: center;
      }
    }

    &__code {
      padding: 0;
      font-size: @font-size-14px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: normal;
    }

    &__count {
      font-size: 0.875rem;
      font-weight: bold;
      line-height: 1.6rem;
    }
  }

  div[id^='webcontracts-contract-left'] {
    padding-left: 0px;
    align-content: center;
    width: 30px;

    .cardcollapseicon {
      width: 24px;
      height: 24px;

      .ui-icon {
        .default-focus-indicator(2px, @primary-color);
        width: 100%;
        height: 100%;
        border-radius: 4px;
        cursor: pointer;
        background-image: url('../../assets/img/icons/glyph/16/small-triangle-down.svg');
        background-position: center;
        background-repeat: no-repeat;
        margin-top: 0;
      }
    }
  }

  div[id^='webcontracts-contract-middle'] {
    padding-right: 16px;
    width: calc(100% - 461px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  div[id^='webcontracts-contract-right'] {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    min-width: fit-content;

    .right-buttons-wrapper {
      display: flex;
    }

    .button {
      float: right;
      margin-top: 20px;
    }

    .button.hidden {
      visibility: hidden;
    }
  }

  .notification-container {
    position: absolute;
    top: 5px;
    right: 15px;
    display: inline-flex;

    .notification {
      font-weight: 600;
      font-size: @font-size-12px;
      font-style: italic;
      padding: 1px;
      border-radius: 4px;
    }

    .card-inner__updating {
      color: #345b34;
      background: #dcfff1;
      margin-right: 5px;
    }

    .card-inner__incart {
      color: #862100;
      background: #fee9a8;
    }
  }

  div[id^='webcontracts-contract-totals'] {
    float: left;
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    width: 181px;
    margin-right: 22px;

    .card-inner__description {
      display: flex;
      justify-content: space-between;
    }
  }

  div[id^='webcontracts-contract-bottom'],
  div[id^='webcontracts-contract-items-bottom'] {
    margin: 5px 15px 15px 15px;
  }

  .result-content .table td button {
    font-size: 0.75rem;
  }

  div[id^='webcontracts-fees-empty-message'] {
    margin: 8px;
    max-width: none;
    background-position: 12px 13px;
  }
}

.card-content.collapsecontainer {
  max-height: 90px;
  overflow: hidden;
  cursor: pointer;

  &--open {
    max-height: unset;
    cursor: default;
    flex-wrap: wrap;

    h2 {
      white-space: unset;
      overflow: visible;
      overflow-wrap: break-word;
    }

    .card-inner__description {
      display: block;
      height: auto;
    }

    .cardcollapseicon {
      .ui-icon {
        background-image: url('../../assets/img/icons/glyph/16/small-triangle-up.svg') !important;
      }
    }
  }
}

#webcontracts-item-details-dialog {
  .dialog-box {
    height: 100%;

    #webcontracts-item-details-content {
      height: 100%;

      .dialog-box-content.scrollWrapper {
        width: 100%;

        .scrollContainer {
          .default-focus-indicator(-2px, @primary-color); //some browsers (eg. Firefox) include this container in the tab sequence when there is a scrollbar
          top: 0;
          height: 100%;
          padding-right: 2px;

          .topFade {
            margin-top: -116px;
          }

          &:focus-visible .topFade,
          &:focus-visible .bottomFade {
            background: none;
          }

          .card-content {
            margin-top: 16px;
          }

          .dialog-card-container {
            &.collapsecontainer {
              .cardcollapseicon {
                .default-focus-indicator(2px, @primary-color);
                height: 24px;
                width: 24px;
                border-radius: 4px;
                cursor: pointer;
                text-align: center;

                .ui-icon {
                  background-image: url('../../assets/img/icons/glyph/16/small-triangle-down.svg') !important;
                }
              }

              &--open .cardcollapseicon .ui-icon {
                background-image: url('../../assets/img/icons/glyph/16/small-triangle-up.svg') !important;
              }
            }
          }
        }
      }

      .dialog-box-content {
        &.mobile {
          width: 100%;
        }

        #webcontracts-contract-items {
          height: 100%;
        }

        .card-inner {
          background: #ffffff;

          &:focus-within {
            border-color: #000;
          }

          &:hover {
            background-color: #f7f7f7 !important;
          }

          &__info {
            flex-wrap: nowrap;
            padding: 19px 0px;

            &.mobile {
              padding: 5px 0px;
            }
          }

          div[id^='webcontracts-contract-items-left'] {
            align-content: center;
            padding: 0 6px;

            .ui-icon {
              background-image: url('../../assets/img/icons/glyph/16/small-triangle-down.svg');
            }
          }
          div[id^='webcontracts-contract-items-right'] {
            display: flex;
            width: -webkit-fill-available;
            flex-wrap: nowrap;

            .contract-items-column {
              display: flex;
              width: 50%;
            }

            .card-inner__description {
              display: flex;
              padding-left: 5px;

              &.mobile {
                align-content: normal;
              }

              strong {
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
}

div[id^='webcontracts-empty-message'] {
  margin-top: 16px;
}

@media screen and (max-height: 500px) {
  .topFade {
    display: none;
  }
}

@media screen and (max-width: 385px) {
  .ui-icon.calendar {
    display: none;
  }
}

@media screen and (max-width: 1500px) {
  .contract-items-column {
    display: block !important;
  }
}

@media @tablet-down {
  .card-inner {
    max-height: 88px;

    .card-inner__info {
      justify-content: space-evenly;
    }

    div[id^='webcontracts-contract-left'] {
      width: 10px;
      margin-left: -15px;
    }

    div[id^='webcontracts-contract-middle'] {
      width: 93%;
    }
  }

  .collapsecontainer--open {
    .card-inner {
      flex-direction: column;
      max-height: unset;
    }

    div[id^='webcontracts-contract-left'] {
      flex-basis: 100%;

      .cardcollapseicon {
        margin-top: 10px;
        text-align: center;
        width: 100%;

        button {
          width: 4% !important;
          min-width: 24px;
        }
      }
    }

    div[id^='webcontracts-contract-middle'] {
      flex-basis: 100%;
    }

    div[id^='webcontracts-contract-right'] {
      flex-basis: 100%;

      .button {
        margin-right: 0;
        margin-top: 8px;
      }

      .button.hidden {
        display: none;
      }
    }
  }
}
</style>
